import { Module } from 'vuex-smart-module';
import NewsActions from './actions';
import NewsGetters from './getters';
import NewsMutations from './mutations';
import NewsState from './state';

export default new Module({
  state: NewsState,
  mutations: NewsMutations,
  actions: NewsActions,
  getters: NewsGetters,
});
